import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { Link, useLocation } from "react-router-dom";
import {IoMdHome} from "react-icons/io"
import { useState } from "react";

const SidebarComponent = ({ toggled, handleClickedOutside }) => {
  // const [toggled, setToggled] = React.useState(false);
  const [rtl, setRtl] = useState(false);
  
  const location = useLocation();

  return (
    <div>
      <Sidebar
        toggled={toggled}
        onBackdropClick={handleClickedOutside}
        image="https://user-images.githubusercontent.com/25878302/144499035-2911184c-76d3-4611-86e7-bc4e8ff84ff5.jpg"
        rtl={rtl}
        breakPoint="md"
        backgroundColor={"#201F5B"}
        rootStyles={
          {
            // color: themes[theme].sidebar.color,
          }
        }
      >
        <div className="text-sm min-h-[98vh] flex flex-col justify-between">
          <div>
            <Menu
              menuItemStyles={{
                button: {
                  // the active class will be added automatically by react router
                  // so we can use it to style the active menu item
                  [`&.active`]: {
                    // backgroundColor: 'blue',
                    color: "blue",
                  },
                },
              }}
            >
              <MenuItem
                icon={
                  <IoMdHome
                    color={
                      location.pathname === "/admin" ? "#F0F0F0" : "#3F3F46"
                    }
                    size={location.pathname === "/admin" ? 25 : 20}
                  />
                }
                component={<Link to="/admin" />}
                active={location.pathname === "/admin"}
                className="text-2xl uppercase font-bold text-primary-color dark:text-primary-color-dark"
              >
                Dashboard
              </MenuItem>

              <MenuItem
                icon={
                  <IoMdHome
                    color={
                      location.pathname === "/admin/destinations"
                        ? "#F0F0F0"
                        : "#3F3F46"
                    }
                    size={location.pathname === "/admin/destinations" ? 25 : 20}
                  />
                }
                component={<Link to="/admin/destinations" />}
                active={location.pathname === "/admin/destinations"}
                className="text-2xl uppercase font-bold text-primary-color dark:text-primary-color-dark"
              >
                Destinations
              </MenuItem>

              <MenuItem
                icon={
                  <IoMdHome
                    color={
                      location.pathname === "/admin/adventures"
                        ? "#F0F0F0"
                        : "#3F3F46"
                    }
                    size={location.pathname === "/admin/adventures" ? 25 : 20}
                  />
                }
                component={<Link to="/admin/adventures" />}
                active={location.pathname === "/admin/adventures"}
                className="text-2xl uppercase font-bold text-primary-color dark:text-primary-color-dark"
              >
                Adventures
              </MenuItem>

              <MenuItem
                icon={
                  <IoMdHome
                    color={
                      location.pathname === "/admin/programmes"
                        ? "#F0F0F0"
                        : "#3F3F46"
                    }
                    size={location.pathname === "/admin/programmes" ? 25 : 20}
                  />
                }
                component={<Link to="/admin/programmes" />}
                active={location.pathname === "/admin/programmes"}
                className="text-2xl uppercase font-bold text-primary-color dark:text-primary-color-dark"
              >
                Programmes
              </MenuItem>
            </Menu>
          </div>
        </div>
      </Sidebar>
    </div>
  );
};


export default SidebarComponent;